import React from "react";

export interface TileProps {
  Title: string;
  Total: number;
  Color: string;  
}

export const Tile: React.FC<TileProps> = ({ Title, Total, Color }) => {
    
    return (
        <div className="tile" style={{backgroundColor: Color}}>
        <div>
            <h3 className="tile-number">{Total}</h3>            
        </div>
        <div>
            <span className="tile-title">{Title}</span>
        </div>
        </div>
    );

}